const deleteButton = document.querySelectorAll(".js-form-delete");

if (deleteButton) {
  deleteButton.forEach((button) => {
    button.addEventListener("click", ()=>{
      const target: HTMLElement | any = button.closest(".js-form-delete-target");
      setTimeout(()=>{
        target.remove();
      },600);
    })
  });
}
